import type { CryptoCurrency, FiatCurrency } from '@0xtorch/core'
import type { AssetRecord } from './types'

export const createAssetRecord = (params: {
  cryptoes: readonly CryptoCurrency[]
  fiats: readonly FiatCurrency[]
}): AssetRecord => {
  const { cryptoes, fiats } = params
  const record: AssetRecord = {
    crypto: {},
    fiat: {},
    symbol: {},
  }
  for (const fiat of fiats) {
    record.fiat[fiat.id] = fiat
    const upperSymbol = fiat.symbol.toUpperCase()
    const symbols = record.symbol[upperSymbol] ?? []
    symbols.push(`fiat/${fiat.id}`)
    record.symbol[upperSymbol] = symbols
  }
  for (const crypto of cryptoes) {
    record.crypto[crypto.id] = crypto
    const upperSymbol = crypto.symbol.toUpperCase()
    const symbols = record.symbol[upperSymbol] ?? []
    symbols.push(`crypto/${crypto.id}`)
    record.symbol[upperSymbol] = symbols
  }
  return record
}
